<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7764_29193)">
      <path
        d="M3 0C1.34602 0 0 1.34602 0 3C0 4.65398 1.34602 6 3 6C4.65398 6 6 4.65398 6 3C6 1.34602 4.65398 0 3 0Z"
        fill="#666666"
      />
      <path
        d="M3 9C1.34602 9 0 10.346 0 12C0 13.654 1.34602 15 3 15C4.65398 15 6 13.654 6 12C6 10.346 4.65398 9 3 9Z"
        fill="#666666"
      />
      <path
        d="M3 18C1.34602 18 0 19.346 0 21C0 22.654 1.34602 24 3 24C4.65398 24 6 22.654 6 21C6 19.346 4.65398 18 3 18Z"
        fill="#666666"
      />
      <path
        d="M12 0C10.346 0 9 1.34602 9 3C9 4.65398 10.346 6 12 6C13.654 6 15 4.65398 15 3C15 1.34602 13.654 0 12 0Z"
        fill="#666666"
      />
      <path
        d="M12 9C10.346 9 9 10.346 9 12C9 13.654 10.346 15 12 15C13.654 15 15 13.654 15 12C15 10.346 13.654 9 12 9Z"
        fill="#666666"
      />
      <path
        d="M12 18C10.346 18 9 19.346 9 21C9 22.654 10.346 24 12 24C13.654 24 15 22.654 15 21C15 19.346 13.654 18 12 18Z"
        fill="#666666"
      />
      <path
        d="M21 6C22.654 6 24 4.65398 24 3C24 1.34602 22.654 0 21 0C19.346 0 18 1.34602 18 3C18 4.65398 19.346 6 21 6Z"
        fill="#666666"
      />
      <path
        d="M21 9C19.346 9 18 10.346 18 12C18 13.654 19.346 15 21 15C22.654 15 24 13.654 24 12C24 10.346 22.654 9 21 9Z"
        fill="#666666"
      />
      <path
        d="M21 18C19.346 18 18 19.346 18 21C18 22.654 19.346 24 21 24C22.654 24 24 22.654 24 21C24 19.346 22.654 18 21 18Z"
        fill="#666666"
      />
    </g>
    <defs>
      <clipPath id="clip0_7764_29193">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
